import React, { useMemo, useState } from "react";

const COLOUR_PALETTE = [
  { bg: "bg-red-50", border: "border-red-200", text: "text-red-700" },
  { bg: "bg-orange-50", border: "border-orange-200", text: "text-orange-700" },
  { bg: "bg-amber-50", border: "border-amber-200", text: "text-amber-700" },
  { bg: "bg-yellow-50", border: "border-yellow-200", text: "text-yellow-700" },
  { bg: "bg-lime-50", border: "border-lime-200", text: "text-lime-700" },
  { bg: "bg-green-50", border: "border-green-200", text: "text-green-700" },
  { bg: "bg-emerald-50", border: "border-emerald-200", text: "text-emerald-700" },
  { bg: "bg-teal-50", border: "border-teal-200", text: "text-teal-700" },
  { bg: "bg-cyan-50", border: "border-cyan-200", text: "text-cyan-700" },
  { bg: "bg-sky-50", border: "border-sky-200", text: "text-sky-700" },
  { bg: "bg-blue-50", border: "border-blue-200", text: "text-blue-700" },
  { bg: "bg-indigo-50", border: "border-indigo-200", text: "text-indigo-700" },
  { bg: "bg-violet-50", border: "border-violet-200", text: "text-violet-700" },
  { bg: "bg-purple-50", border: "border-purple-200", text: "text-purple-700" },
  { bg: "bg-fuchsia-50", border: "border-fuchsia-200", text: "text-fuchsia-700" },
  { bg: "bg-pink-50", border: "border-pink-200", text: "text-pink-700" },
  { bg: "bg-rose-50", border: "border-rose-200", text: "text-rose-700" },
];

const hashString = (str = "") => {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return h;
};

const AgentAvatar = ({
  size = 44,
  nameKey = "",
  className = "",
  textClass = "text-[1rem]",
}) => {
  const agentName =
    (typeof nameKey === "string" && nameKey.trim()) ||
    localStorage.getItem("agentName") ||
    "";
  const avatarUrl = localStorage.getItem("avatarurl") || "";

  const initials = useMemo(() => {
    const parts = agentName.trim().split(/\s+/).filter(Boolean);
    const first = parts[0]?.[0] || "";
    const second = parts[1]?.[0] || parts[0]?.[1] || "";
    return `${first}${second}`.toUpperCase();
  }, [agentName]);

  const [imgError, setImgError] = useState(false);
  const shouldShowImage = !!avatarUrl && !imgError;

  const colour = useMemo(() => {
    const idx = hashString(agentName || "Agent") % COLOUR_PALETTE.length;
    return COLOUR_PALETTE[idx];
  }, [agentName]);

  if (shouldShowImage) {
    return (
      <img
        src={avatarUrl}
        alt={agentName || "Agent"}
        width={size}
        height={size}
        onError={() => setImgError(true)}
        className={`rounded-full object-cover border-2 border-blue-100 bg-blue-50 ${className}`}
        style={{ width: size, height: size }}
      />
    );
  }

  return (
    <div
      className={`rounded-full flex items-center justify-center border-1 ${colour.bg} ${colour.border} ${className}`}
      style={{ width: size, height: size }}
      aria-label={agentName || "Agent"}
      title={agentName || ""}
    >
      <span className={`${textClass} ${colour.text}`}>{initials || "?"}</span>
    </div>
  );
};

export default AgentAvatar;
